import React,{useState} from 'react';
import {QRCodeSVG} from 'qrcode.react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiMessageCircle,FiLink,FiCheck,FiGrid,FiDownload}=FiIcons;

export default function ReviewShareActions({business,url}) {
  const [copied,setCopied]=useState(false);
  const [showQR,setShowQR]=useState(false);
  const message=`Share your experience with ${business.business_name}: ${url}`;

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(()=> setCopied(false),2200);
    } catch {
      setCopied(false);
    }
  }

  function downloadQR() {
    const svg=document.getElementById('business-review-qr');
    if (!svg) return;
    const blob=new Blob([new XMLSerializer().serializeToString(svg)],{type: 'image/svg+xml;charset=utf-8'});
    const objectUrl=URL.createObjectURL(blob);
    const link=document.createElement('a');
    link.href=objectUrl;
    link.download=`${business.slug}-review-qr.svg`;
    link.click();
    window.setTimeout(()=> URL.revokeObjectURL(objectUrl),1000);
  }

  return (
    <section className="mt-9 rounded-3xl border border-[#3fc0fa]/30 bg-[#101c2d] p-5 sm:p-7">
      <h2 className="text-xl font-black text-white sm:text-2xl">Get your review link out there</h2>
      <p className="mt-2 text-sm text-slate-300">Text it,copy it,or display a QR code.</p>
      <div className="mt-6 grid gap-3 sm:grid-cols-3">
        <a href={`sms:?&body=${encodeURIComponent(message)}`} className="site-button flex min-h-24 flex-col items-center justify-center gap-2 rounded-2xl px-4 py-5 text-center text-base font-extrabold shadow-lg shadow-[#3fc0fa]/10">
          <SafeIcon icon={FiMessageCircle} className="h-7 w-7" />
          Send by text
        </a>
        <button type="button" onClick={copyLink} className="flex min-h-24 flex-col items-center justify-center gap-2 rounded-2xl bg-[#a7e2be] px-4 py-5 text-base font-extrabold text-[#0b1423] shadow-lg shadow-[#a7e2be]/10 transition-all hover:-translate-y-0.5 hover:bg-[#c6f2d6]">
          <SafeIcon icon={copied ? FiCheck : FiLink} className="h-7 w-7" />
          {copied ? 'Link copied!' : 'Copy review link'}
        </button>
        <button type="button" onClick={()=> setShowQR((visible)=> !visible)} aria-expanded={showQR} className="flex min-h-24 flex-col items-center justify-center gap-2 rounded-2xl bg-[#f8b86a] px-4 py-5 text-base font-extrabold text-[#0b1423] shadow-lg shadow-[#f8b86a]/10 transition-all hover:-translate-y-0.5 hover:bg-[#ffd098]">
          <SafeIcon icon={FiGrid} className="h-7 w-7" />
          QR Code
        </button>
      </div>
      <a href={url} className="mt-5 block break-all rounded-xl border border-white/10 bg-[#19283d] px-4 py-3 text-sm text-[#3fc0fa] underline underline-offset-4 hover:text-white">
        {url}
      </a>
      {showQR && (
        <div className="mt-6 inline-flex flex-col items-center gap-4 rounded-2xl bg-white p-6 text-center text-[#0b1423]">
          <QRCodeSVG id="business-review-qr" value={url} size={192} marginSize={2} />
          <p className="text-sm font-semibold">Scan to share your experience</p>
          <button type="button" onClick={downloadQR} className="inline-flex items-center gap-2 rounded-full bg-[#0b1423] px-5 py-3 text-sm font-bold text-white">
            <SafeIcon icon={FiDownload} /> Download QR code
          </button>
        </div>
      )}
    </section>
  );
}